import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { getMonthYearFromBillingPeriod, InvoiceData } from '@/shared/types/invoiceTypes';
import { SingleResponse } from '@/shared/types/responseTypes';

// Get Account Invoice Data Query
export const useAccountInvoiceData = (billingPeriod: string | undefined) => {
  const parsedBillingPeriod = getMonthYearFromBillingPeriod(billingPeriod);

  return useQuery({
    queryKey: ['invoices', parsedBillingPeriod],
    queryFn: async () => {
      const response = await apiClient.get<SingleResponse<InvoiceData>>(
        `/api/v1/invoices`,
        { params: { month: parsedBillingPeriod } }
      );
      return response.data;
    },
    enabled: !!parsedBillingPeriod
  });
};
